module.exports = __webpack_public_path__ + "static/media/freedomly-pro-1.5e9b830a.webp";